import * as React from 'react';
import { IAppPropsWithRoute } from '../../common/types';
import { withRouter } from 'react-router-dom';
import { useState } from 'react';
import ViewCustomersWidget from './ViewCustomersWidget';
import { useDispatch, useSelector } from 'react-redux';
import { showNavbar } from '../../store/modules/appStateSlice';

interface ViewCustomersPageProps extends IAppPropsWithRoute {
};

function ViewCustomersPage(props: ViewCustomersPageProps): JSX.Element {
    const dispatch = useDispatch();
    React.useEffect(() => {
        dispatch(showNavbar(true));
    }, [])
   
    return (
        <React.Fragment>
            <ViewCustomersWidget/>
        </React.Fragment>
    );
}

export default React.memo(withRouter(ViewCustomersPage));